<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <div>
                  <img
                    src="https://firebasestorage.googleapis.com/v0/b/naoki-c4da8.appspot.com/o/logo.png?alt=media&token=63f0128e-b01d-48e9-afb1-4c4853c97110"
                    style="width: 100%"
                  />
                </div>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-dark py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <b-form>
                  <div
                    v-if="lang == 0"
                    @click="changelang()"
                    style="position: absolute; top: 3px; right: 5px"
                  >ລາວ</div>
                  <div
                    v-if="lang == 1"
                    @click="changelang()"
                    style="position: absolute; top: 3px; right: 5px"
                  >Eng</div>
                  <h1>{{t(['Login','ເຂົ້າສູ່ລະບົບ'])}}</h1>
                  <p class="text-muted">{{t(['Sign In to your account','ເຂົ້າສູ່ລະບົບ'])}}</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="fa fa-envelope"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="email"
                      v-model="email"
                      @keyup.native.enter="login()"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="fa fa-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      @keyup.native.enter="login()"
                      v-model="password"
                      type="password"
                      class="form-control"
                      placeholder="Password"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button
                        variant="primary"
                        @click="login()"
                        class="px-4"
                      >{{t(['Login','ເຂົ້າສູ່ລະບົບ'])}}</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button
                        variant="link"
                        class="px-0"
                      >{{t(['Forgot password','ລືມລະຫັດຜ່ານ'])}}?</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";
import Swal from "sweetalert2";
export default {
  name: "Login",
  data() {
    return {
      email: "admin@naoki.com",
      password: "123456",
      lang: null
    };
  },
  mounted() {
    this.lang = this.$store.get("lang") * 1;
  },
  methods: {
    changelang() {
      this.lang = this.lang == 0 ? 1 : 0;
      this.$store.set("lang", this.lang);
    },
    login() {
      if (this.email.indexOf("@naoki.com") < 1) return;
      Swal.showLoading();
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(res => {
          Swal.close();
          this.$router.replace("home");
          this.$store.set("user", res);
        })
        .catch(err => {
          Swal.close();
          Swal.fire("Error", err.message, "error");
        });
    },
    logout() {}
  }
};
</script>
